import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.18903 5.5H9V7.5H5V9.5H9V11.5H5V13C5 13.1682 5.00695 13.335 5.02059 13.5H9V15.5H5.54436C6.49234 17.5655 8.57787 19 11 19V20H6V22H18V20H13V19C15.4221 19 17.5077 17.5655 18.4556 15.5H15V13.5H18.9794C18.9931 13.335 19 13.1682 19 13V11.5H15V9.5H19V7.5H15V5.5H18.811C18.1449 2.91216 15.7958 1 13 1H11C8.20424 1 5.85509 2.91216 5.18903 5.5Z"}}]};

const MicrophoneFilled = Vue.extend<IconProps>({
  name: 'MicrophoneFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'microphone-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MicrophoneFilled;
